import { eventTracker } from '@futrli/tracking';
import { tracker } from './defaults';

export const { trackCTA, trackEvent, trackViewModal } = eventTracker(() => tracker);
